<template>

    <div>
        <div class="modal fade" id="addInvoiceModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Factuur toevoegen</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label for="" class="control-label col-sm-3"></label>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-xl-4">{{ lang.get("global.date") }}:</label>
                                <div class="col-xl-8">
                                    <date-picker v-model="form.date" format="DD-MM-YYYY" type="date" lang="en"></date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4">Onderwerp:</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" tabindex="1" v-model="form.subject" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4">Contact:</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input type="text" class="form-control" disabled tabindex="1" :value="getSelectedContact" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-info btn-sm" @click="$refs.crmSelector.openSelector()" v-tooltip="'Contact zoeken'"><i class="mdi mdi-account-search"></i></button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4">Bedrag</label>
                                <div class="col-sm-8">
                                    <money v-model="form.amount" v-bind="money" class="form-control"></money>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4">{{ lang.get("tasks.term") }}</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input type="number" class="form-control" v-model="form.paymentterm" />
                                        <span class="input-group-addon">
                                            {{ lang.get("global.days") }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4">Herhalen</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input type="number" class="form-control" v-model="form.months" />
                                        <span class="input-group-addon">
                                            {{ lang.get("global.months") }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-8 col-sm-offset-4">
                                    <button class="btn btn-primary btn-sm" :disabled="!canSubmit" @click="onSubmit">Factuur toevoegen</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <crm-selector
            ref="crmSelector"
            :on-selected="onCrmSelected"
        ></crm-selector>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import Lang from '../../Lang';
import CrmSelector from '../Common/Selectors/CrmSelector';
import {Money} from 'v-money';
import DatePicker from 'vue2-datepicker';
import {mapGetters} from "vuex";

export default {
    components: {
        CrmSelector,
        Money,
        DatePicker,
    },
    computed: {
        ...mapGetters([
            'getAuth',
        ]),

        canSubmit() {
            return this.posting === false &&
                this.form.subject !== "" &&
                this.form.amount !== 0 &&
                this.form.date !== null &&
                !isNaN(this.form.paymentterm) && this.form.paymentterm > 0 &&
                !isNaN(this.form.months) && this.form.months >= 0 &&
                this.selectedContact !== null;
        },

        getPaymentTerm() {
            return this.getAuth.settings.financial.invoice.payment_term;
        },

        getSelectedContact(){
            if (this.selectedContact === null) {
                return "";
            }
            // Check
            if (this.selectedContact.isCompany === true && this.selectedContact.isContact === true) {
                return this.selectedContact.full_name + " (" + this.selectedContact.company_name + ")";
            } else if (this.selectedContact.isContact === true) {
                return this.selectedContact.full_name;
            } else {
                return this.selectedContact.company_name;
            }
        },
        postData() {
            return {
                subject:this.form.subject,
                amount:this.form.amount,
                date:moment(this.form.date).format("YYYY-MM-DD"),
                paymentterm: this.form.paymentterm,
                contact: this.selectedContact.uuid,
                months: this.form.months,
            };
        },
    },

    data() {
        return {
            form: {
                subject:"",
                amount:0,
                date:moment(),
                paymentterm: this.getPaymentTerm,
                months:0,
            },
            lang:Lang,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            posting:false,
            selectedContact: null,
        }
    },

    methods: {

        closeModal() {
            $('#addInvoiceModal').modal('hide');
        },

        onCrmSelected(item){
            this.selectedContact = item;
            this.$refs.crmSelector.closeSelector();
        },

        onSubmit() {
            this.posting = true;
            // process the data
            axios.post(this.addInvoiceUri, this.postData)
            .then(resp => {
                this.$snotify.success("De factuur is toegevoegd");
                this.$emit("invoice-added");
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het toevoegen van de factuur"))
            .finally(() => this.posting = false);
        },

        openModal() {
            $('#addInvoiceModal').modal('show');
            this.form = {
                subject:"",
                amount:0,
                date:moment(),
                paymentterm: this.getPaymentTerm,
                months:0,
            };
            this.selectedContact = null;
        },

    },

    name: "BusinessAddInvoiceModal",

    props: {
        addInvoiceUri: {
            required:true,
            type:String,
        },
    },

}

</script>
